import videojs from 'video.js';

import { Event } from '@src/types/event';

const BigPlayButton = videojs.getComponent('BigPlayButton');

class CustomBigPlayButton extends BigPlayButton {
  public handleClick(evt: videojs.EventTarget.Event) {
    this.player().trigger(Event.X_CLICK_BIGPLAYBTN);
    super.handleClick(evt);
  }
}

// override video.js original BigPlayButton
videojs.registerComponent('BigPlayButton', CustomBigPlayButton);

export default CustomBigPlayButton;
